import apiClient, { ApiResponse } from './client';

export interface WebhookConfig {
  id: string;
  organization_id: string;
  name: string | null;
  url: string;
  enabled: boolean;
  notify_on_active_session: boolean;
  notify_on_booked: boolean;
  notify_on_qualified: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateWebhookRequest {
  name?: string;
  url: string;
  secret?: string;
  notify_on_active_session?: boolean;
  notify_on_booked?: boolean;
  notify_on_qualified?: boolean;
}

export interface UpdateWebhookRequest {
  name?: string;
  url?: string;
  secret?: string;
  enabled?: boolean;
  notify_on_active_session?: boolean;
  notify_on_booked?: boolean;
  notify_on_qualified?: boolean;
}

export class WebhooksService {
  async listWebhooks(organizationId: string): Promise<ApiResponse<{ webhooks: WebhookConfig[] }>> {
    return apiClient.get<{ webhooks: WebhookConfig[] }>('/api/webhooks', { organization_id: organizationId });
  }

  async createWebhook(organizationId: string, data: CreateWebhookRequest): Promise<ApiResponse<WebhookConfig>> {
    return apiClient.post<WebhookConfig>(`/api/webhooks?organization_id=${encodeURIComponent(organizationId)}`, data);
  }

  async updateWebhook(webhookId: string, data: UpdateWebhookRequest): Promise<ApiResponse<WebhookConfig>> {
    return apiClient.put<WebhookConfig>(`/api/webhooks/${webhookId}`, data);
  }

  async deleteWebhook(webhookId: string): Promise<ApiResponse<{ message: string }>> {
    return apiClient.delete<{ message: string }>(`/api/webhooks/${webhookId}`);
  }

  async testWebhook(webhookId: string): Promise<ApiResponse<{ success: boolean; status_code?: number; message?: string }>> {
    return apiClient.post<{ success: boolean; status_code?: number; message?: string }>(`/api/webhooks/${webhookId}/test`);
  }
}

const webhooksService = new WebhooksService();
export default webhooksService;
